// extracted by mini-css-extract-plugin
export var closeButton = "_96-0";